














import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class Frontpage extends Vue {
  @Prop() readonly doc!: any;
}
